export default __webpack_public_path__ + "static/media/mindmovie phone.9f335c19.jpg";